<template>
  <p v-if="loading" style="text-align: center;padding: 20px">
      <span style="font-size: 25px;">
          <i class="fa fa-spinner fa-spin"></i> Loading...
      </span>
  </p>
  <b-row v-else>
    <b-col cols="12" xl="12" sm="12">
      <transition name="slide">
        <b-card>
          <b-button variant="primary" class="pull-right" @click="showModal">Create New User</b-button><br/><br/>

          <div v-if="tableData.length < 1">
            <p style="font-size: 15px;" class="text-center">
              <i>There are currently no adminstrators at this moment. Use the button above to create an admin</i>
            </p>
          </div>
          <div v-else>
            <v-client-table :data="tableData" :columns="columns" :options="options">
              <!-- <b-link slot="actions" slot-scope="props" to="#" @click="viewLoanDetails(props.row.actions)"><i class="fa fa-eye"> </i> View Details</b-link> -->
              <div slot="status" slot-scope="props">
                <b-badge v-show="props.row.status === 1" variant="success" pill>Verified</b-badge>
                <b-badge v-show="props.row.status === 0" variant="warning" pill>Unverified</b-badge>
              </div>
            </v-client-table>
          </div>
        <b-pagination
          align="left"
          v-model="response.current_page"
          :total-rows="response.total"
          :per-page="response.per_page"
          @change="getPaginated"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
        ></b-pagination>
        </b-card>
      </transition>
    </b-col>
    <b-modal ref="modal-1" hide-footer title="Add New Admin User">
      <form @submit.prevent="createNewUser">
        <div class="form-group">
          <label>First Name</label>
          <input class="form-control" autocomplete="off" v-model="form.first_name" type="text" placeholder="User First Name" :required="true" />
        </div>
        <div class="form-group">
          <label>Last Name</label>
          <input class="form-control" autocomplete="off" v-model="form.last_name" type="text" placeholder="User Last Name" :required="true" />
        </div>
        <div class="form-group">
          <label>Email Address</label>
          <input class="form-control" autocomplete="off" v-model="form.email" type="email" placeholder="Email Address" :required="true" />
        </div>
        <div class="form-group">
          <label>Password</label>
          <input class="form-control" autocomplete="off" v-model="form.password" type="password" placeholder="Password" :required="true" />
        </div>
        <div class="form-group">
          <label>Role</label>
          <select v-model="form.roles" :required="true" class="form-control">
            <option v-for="(role, index) in roles" v-bind:key="index" :value="role.name">{{role.name.toUpperCase()}}</option>
          </select>
        </div><hr/>
        <div class="pull-right">
          <b-button class="mr-1" squared variant="danger" size="lg" @click="hideModal">Cancel</b-button>
          <b-button type="button" variant="success" v-if="isLoading" disabled>
              <i class="fa fa-spinner fa-spin"></i>
              Please wait...
          </b-button>
          <b-button type="submit" variant="success" class="btn-lg btn-success" v-else>
              <i class="fa fa-send"></i>
              Submit
          </b-button>
        </div>
      </form>
    </b-modal>
  </b-row>
</template>

<script>
import { baseURL } from '../../shared/utils';
import { mapState, mapGetters, mapActions } from 'vuex';
import { allUserStaffs } from '@/services/userService';

export default {
  name: 'Users',
  data: () => {
    return {
      columns: ['id', 'first_name', 'last_name', 'email', 'status', 'role', 'actions'],
      tableData: [],
      options: {
        headings: {
          id: 'S/N',
          first_name: 'First Name',
          last_name: 'Last Name',
          email: 'Email',
          status: 'Status',
          role: 'Role',
          actions: 'View Details'
        },
        sortable: ['first_name', 'last_name', 'email', 'role'],
        filterable: ['first_name', 'last_name', 'email', 'role'],
        perPage: 50
      },
      response: {},
      form: {
        first_name: '',
        last_name: '',
        password: '',
        roles: '',
        email: '',
        bank_code: null
      },
      roles: [],
      loading: false,
      isLoading: false
    }
  },
  created() {
    this.fetchData(1);
    this.getRoles();
  },
  methods: {
    ...mapActions([
      'createUser'
    ]),
    async fetchData(page) {
      this.loading = true;
      try {
        const {data: {datas}} = await allUserStaffs(page);
        this.response = datas;
        const users = datas.data;
        users.map((user, index) => {
          this.tableData.push({
            id: ++index,
            first_name: user.first_name  || '',
            last_name:  user.last_name || '',
            email: user.email  || '',
            status: user.is_active,
            role:( (user||{}).roles[0]||{}).name,
            actions: ''
          });
        });
      }
      catch(err) {}
      finally {
        this.loading = false;
      }
    },
    getPaginated(page_number) {
      this.fetchData(page_number);
    },
    async createNewUser() {
      this.isLoading = true;
      const result = await this.createUser(this.form);
      if (result) {
        this.isLoading = false;
        this.$refs['modal-1'].hide();
        this.$swal('Created Successfully!','Administrator has been created.','success');
        window.location.reload();
      }
      else {
        this.isLoading = false;
      }
    },
    getRowCount (items) {
      return items.length
    },
    userLink (id) {
      return `users/${id.toString()}`
    },
    rowClicked (item) {
      const userLink = this.userLink(item.id)
      this.$router.push({path: userLink})
    },
    getRoles() {
      this.$http.get(`${baseURL}roles`)
      .then(({data}) => {
        let roles = data.datas.data.filter(role => role.name !== 'customer');
        this.roles = roles;
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    hideModal() {
      this.$refs['modal-1'].hide()
    },
    showModal() {
      this.$refs['modal-1'].show()
    },
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
